import {CalculatorCoordinateData} from '../helper/calculator.data.interface';
import {Calculator} from '../helper/calculator';

export class DataEntryModel {

    protected _countryCode: string;
    protected _transaction: number;
    protected _active: boolean;
    protected _error: boolean;

    private _coordinateData: CalculatorCoordinateData;

    get coordinates(): CalculatorCoordinateData {
        return this._coordinateData;
    }

    get sizeMod(): number {
        return Math.log10(this._transaction) * 0.3 + 0.5;
    }

    get active(): boolean{
        return this._active;
    }

    get error(): boolean{
        return this._error;
    }

    public constructor(countryCode: string, transaction: number) {
        this._countryCode = countryCode;
        this._transaction = transaction;
        this._active = true;
    }

    public init(): DataEntryModel {
        if (!this._countryCode || !this._transaction)
            return null;

        this._coordinateData = Calculator.GetCoordinatesByCode(this._countryCode);

        if (this._coordinateData)
            return this;
        return null;
    }

    public deactivate() : Promise<boolean> {
        this._active = false;

        return new Promise<boolean>((resolve, reject) => {
            setTimeout(() => {
                resolve(true);
            }, 1000)
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/map-chart/model/data-entry.model.ts